import { Group } from 'three';
import { decorationSettings } from '../../../../data/settings';
import { DecorObject3d } from './DecorObject3d';

export class DecorBlock extends Group {
    #key;
    #elements3d;
    #elements3dToInvalidate;

    constructor(key) {
        super();

        this.#key = key;
        this.hasInvalidate = true;
    }

    construct() {
        const { elements } = decorationSettings[this.#key];

        this.#elements3d = elements.map((elem) => {
            const decor3d = new DecorObject3d(elem);

            this.add(decor3d);

            return decor3d;
        });

        this.#elements3dToInvalidate = this.#elements3d.filter((obj3d) => obj3d.hasInvalidate);
    }

    update(orientation) {
        this.#elements3d.forEach((decor3d) => decor3d.update(orientation));
    }

    play() {
        this.#elements3d.forEach((decor3d) => decor3d.play());
    }

    stop() {
        this.#elements3d.forEach((decor3d) => decor3d.stop());
    }

    destroy() {
        this.#elements3d.forEach((decor3d) => decor3d.destroy());
    }

    invalidate(t, dt) {
        if (this.#elements3dToInvalidate) this.#elements3dToInvalidate.forEach((decor3d) => decor3d.invalidate(t, dt));
    }
}
